module.exports = __webpack_public_path__ + "fonts/Prompt-Thin.ddcfbf89.ttf";